export default "__VITE_ASSET__IzKu6yo1BFbbjFiqjn40XQ__"